import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { ReactElement } from 'react'
import styled from 'styled-components'

import {
  IDraggedLocation,
  ILocationRemove,
  IRoutingProjectPlanModel,
  IRoutingProjectPlanOptimization,
  IRoutingProjectPlanRouteStop
} from 'features/RoutingProjects/types'
import { RouteStopItem } from 'features/RoutingProjects/components/RoutingProjectSidebar/OptimizedRoutesList/StopItem'

const StopsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

interface IRouteStopsProps {
  stops: IRoutingProjectPlanRouteStop[]
  rgbColor: string
  routeIndex: number
  draggedLocation: IDraggedLocation | null
  onLocationRemove?: (args: ILocationRemove) => void
  planModel: IRoutingProjectPlanModel
  currentOptimization: IRoutingProjectPlanOptimization
}

export const RouteStops = ({
  stops,
  rgbColor,
  routeIndex,
  draggedLocation,
  onLocationRemove,
  planModel,
  currentOptimization
}: IRouteStopsProps): ReactElement => {
  const sortableItems = stops.map((stop) => stop.sortableItemId)
  const route = currentOptimization.routes[routeIndex]
  return (
    <SortableContext items={sortableItems} strategy={verticalListSortingStrategy} disabled={route.isLocked}>
      <StopsList>
        {stops.map((stop, stopIndex): ReactElement => {
          return (
            <RouteStopItem
              key={stop.sortableItemId}
              stop={stop}
              rgbColor={rgbColor}
              stopIndex={stopIndex}
              routeIndex={routeIndex}
              draggedLocation={draggedLocation}
              onLocationRemove={onLocationRemove}
              planModel={planModel}
              currentOptimization={currentOptimization}
            />
          )
        })}
      </StopsList>
    </SortableContext>
  )
}
